import { http } from 'src/services/agents/http'
import * as types from './types'

export * from './types'

export const getMemoryThreads = (params: types.IGetMemoryThreadsParams) =>
  http.get<types.IGetMemoryThreadsData>('/memory/threads', { params })

export const getMemoryThreadsPaginated = (
  params: types.IGetMemoryThreadsPaginatedParams
) =>
  http.get<types.IGetMemoryThreadsData>('/memory/threads/paginated', { params })

export const postMemoryThreads = ({
  agentId,
  ...data
}: types.IPostMemoryThreadsParams) =>
  http.post<types.IPostMemoryThreadsData>('/memory/threads', data, {
    params: { agentId },
  })

export const getMemoryThreadsItem = ({
  threadId,
  ...params
}: types.IGetMemoryThreadsItemParams) =>
  http.get<types.IGetMemoryThreadsData>(`/memory/threads/${threadId}`, {
    params,
  })

export const patchMemoryThreadsItem = ({
  threadId,
  ...params
}: types.IPatchMemoryThreadsItemParams) =>
  http.patch<types.IPatchMemoryThreadsItemData>(`/memory/threads/${threadId}`, {
    params,
  })

export const deleteMemoryThreadsItem = ({
  threadId,
  ...params
}: types.IDeleteMemoryThreadsItemParams) =>
  http.patch<types.IDeleteMemoryThreadsItemData>(
    `/memory/threads/${threadId}`,
    {
      params,
    }
  )

export const getMemoryThreadsItemMessages = ({
  threadId,
  ...params
}: types.IGetMemoryThreadsItemMessagesParams) =>
  http.get<types.IGetMemoryThreadsItemMessagesData>(
    `/memory/threads/${threadId}/messages`,
    { params }
  )
